module.exports = __webpack_public_path__ + "img/sel-logo-mini.0792692c.jpg";